// extracted by mini-css-extract-plugin
module.exports = {"emojiWrap":"LikeDislike_emojiWrap__1hAq-","wrap":"LikeDislike_wrap__2BVpm","likeCount":"LikeDislike_likeCount__3JPI3","activeEmoji":"LikeDislike_activeEmoji__3Dw1G"};